import React, { useCallback, useEffect, useState } from 'react';
import "swiper/css";
import { fetchData } from '../../fetcher';
import styles from './MagazineContent.module.scss';
import MagazineArticle from '../MagazineArticle/MagazineArticle';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode"
import "swiper/css/pagination"
import SwiperCore, {
    Autoplay, Pagination, Navigation, FreeMode, Mousewheel
} from 'swiper';

SwiperCore.use([Autoplay, Pagination, Navigation, FreeMode, Mousewheel]);

const MagazineContent = ({data}) => {
    const [articles, setArticles] = useState([])

    useEffect(() => {
        if (data && data?.items) {
            setArticles(data.items)
        }
    }, [data])

    console.log('articles', articles);

    return (
        <div className={`magazine ${styles.magazineContent}`}>
            <div>
                <MagazineArticle isFirst key={data?.title} desc={data?.html} title={data?.title} link={data?.cta?.link} />
            </div>
            <div className={styles.magazineList}>
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={30}
                    freeMode    
                >
                    {articles && articles.map((d,i) => (                        
                        <SwiperSlide key={d.title + i}>
                            <MagazineArticle key={d.title} desc={d.html} title={d.title} imgSrc={d.image?.src} link={d?.link} />
                        </SwiperSlide>                        
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default MagazineContent;